import { User } from '@supabase/supabase-js';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { fetchUserTeam } from '../services/userTeam';

export type UserTeam = {
  id: string;
  email: string | null;
  avatarUrl: string | null;
  fullName: string | null;
  teamId: string | null;
  employeeId: string | null;
  checkInTimes: string[] | null;
  shadowId: string | null;
  shadowTo: string | null;
  activeSprint: { id: string; createdAt: string } | null;
  accessibleTeams: { id: string; name: string }[];
  role: string;
  userType: string;
  isTeamMember: boolean;
};

export function useUserTeamQuery(
  user: User | null,
): UseQueryResult<UserTeam | null, Error> {
  return useQuery({
    queryKey: ['userTeam', user?.id],
    queryFn: async () => {
      if (!user) return null;

      const data = await fetchUserTeam(user?.id);
      if (!data) return null;

      return {
        id: user?.id,
        email: user.email ?? null,
        avatarUrl: user.user_metadata?.avatar_url as string | null,
        fullName: user.user_metadata?.full_name as string | null,
        teamId: data.id,
        checkInTimes: data.check_in_times,
        activeSprint:
          data.sprints && data.sprints[0] !== undefined
            ? {
                id: data.sprints[0].id,
                createdAt: data.sprints[0].created_at,
              }
            : null,
        accessibleTeams: data.accessibleTeams || [],
        role: data.role || '',
        userType: data.userType || '',
        shadowId: data.shadow_id,
        shadowTo: data.shadow_to,
        isTeamMember: !!data.id,
        employeeId: data.employeeId,
      } satisfies UserTeam;
    },
    enabled: !!user,
  });
}
